document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select], [data-variant-radio]')) return;
  const form = event.target.closest('form');
  const option = event.target.matches('[data-variant-radio]') ? event.target : event.target.selectedOptions[0];
  const button = form.querySelector('[data-add-to-cart]');
  const status = form.querySelector('[data-stock-status]');
  const available = option.dataset.available === 'true';
  button.disabled = !available;
  button.textContent = available ? button.dataset.addLabel : button.dataset.soldOut;
  form.querySelector('[data-variant-price]').textContent = option.dataset.price;
  status.textContent = available ? status.dataset.inStock : status.dataset.soldOut;
  const url = new URL(location.href);
  url.searchParams.set('variant', option.value);
  history.replaceState({}, '', url);
  const media = document.getElementById(option.dataset.media);
  if (media) media.parentElement.prepend(media);
});
